import React from 'react';
import { Box, Container, Flex, Text } from '@chakra-ui/react';
import SvgLocation from '../../../assets/svg/SvgLocation';
import { links } from '../navDatat';
import { Link } from 'react-scroll';
import { NavLink } from 'react-router-dom';
import { ADDRESS, PHONE_NUMBER_LINK } from '../../../helpers/adminData';
import MobileNavbar from './MobileNavbar';

const Header = () => {
  return (
    <Box bg='#FFFFFF' pos='fixed' top='0' left='0' w='full' h={{ base: '82px', md: '76px' }} pt='12.81px' pb='12.81px'
         zIndex='50'>
      <Container maxW='container.xl' display='flex' justifyContent='space-between' alignItems='center'>
        <Flex display={{ base: 'none', md: 'flex' }} alignItems='center'>
          <SvgLocation />
          <a target={`_blank`} href={`${ADDRESS}`}><Text ml='13.13px' fontFamily='Raleway' fontWeight='400'
                                                         fontSize='14px' color='#000000'>Адрес</Text></a>
        </Flex>
        <Flex justifyContent='center' alignItems='center'>
          {links.slice(0, 2).map(({ id, link, item }) => (
            <Box key={id} display={{ base: 'none', md: 'block' }} cursor='pointer' ml='70px'>
              <Link to={link} smooth duration={500}>
                <Text fontFamily='Raleway' fontSize='14px' fontWeight='600' color='#1B1918'>{item}</Text>
              </Link>
            </Box>
          ))}
          {links.slice(2, 3).map(({ id, link, item }) => (
            <Box key={id} ml={{ base: '0', md: '82px' }} mr={{ base: '0', md: '63.28px' }}>
              <Link to={link} smooth duration={500}>
                {item}
              </Link>
            </Box>
          ))}
          {links.slice(3, 5).map(({ id, link, item }) => (
            <Box key={id} display={{ base: 'none', md: 'block' }} mr='70px'>
              <Link to={link} smooth duration={500}>
                <Text cursor='pointer' fontFamily='Raleway' fontSize='14px' fontWeight='600'
                      color='#1B1918'>{item}</Text>
              </Link>
            </Box>
          ))}

            <Box display={{ base: 'none', md: 'block' }}  fontWeight="400" fontStyle={'normal'}>
                <NavLink to={PHONE_NUMBER_LINK}>
                    +996 555-86-60-70
                </NavLink>
            </Box>

        </Flex>
        <Box visibility={{ base: 'visible', md: 'hidden' }}>
          <MobileNavbar />
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
